export default __webpack_public_path__ + "static/Code Version Control-355820577b189045b79b1bb8c4d23163.svg";